import type { ReactNode } from 'react';

export type StatDelta = 'pos' | 'neg' | 'warn' | 'neutral';

interface StatProps {
  label: string;
  value: ReactNode;
  delta?: ReactNode;
  deltaType?: StatDelta;
  mono?: boolean;
}

const DELTA_COLOR: Record<StatDelta, string> = {
  pos: 'var(--rx-positive)',
  neg: 'var(--rx-negative)',
  warn: 'var(--rx-warn)',
  neutral: 'var(--rx-text-2)',
};

export function Stat({
  label,
  value,
  delta,
  deltaType = 'neutral',
  mono = true,
}: StatProps): JSX.Element {
  return (
    <div className="rx-card flex-1">
      <div
        style={{
          fontSize: 11,
          color: 'var(--rx-text-3)',
          letterSpacing: '0.4px',
          textTransform: 'uppercase',
          fontWeight: 500,
        }}
      >
        {label}
      </div>
      <div
        className={mono ? 'rx-mono' : ''}
        style={{
          marginTop: 8,
          fontSize: 22,
          fontWeight: 500,
          color: 'var(--rx-text)',
          letterSpacing: '-0.5px',
        }}
      >
        {value}
      </div>
      {delta && (
        <div
          style={{
            marginTop: 6,
            fontSize: 11,
            fontWeight: 500,
            color: DELTA_COLOR[deltaType],
            display: 'flex',
            alignItems: 'center',
            gap: 3,
          }}
        >
          <span className="rx-mono">{delta}</span>
        </div>
      )}
    </div>
  );
}
